const redirectTimeOut = 1500;

export default redirectTimeOut;
